import { Pipe, PipeTransform } from '@angular/core';
import { DateUtil } from 'app/core/utils/DateUtil';

@Pipe({
  name: 'showDateFormat',
  pure: false
})

export class ShowDateFormat implements PipeTransform {
  transform(value: any, typeFormat: number): any {
    if (!value) return '';
    if (typeFormat === 1)
      return DateUtil.formatAMPM(value); // MM/DD/YYYY HH:mm PM/AM
    if (typeFormat === 2)
      return DateUtil.formatAMPMDate(value); // MM/DD/YYYY
    if (typeFormat === 3)
      return DateUtil.formatAMPMTime(value); // HH:mm PM/AM
    if (typeFormat === 4)
      return DateUtil.convertFromLocalToUTCFullMiliseconds(value); // YYYY-MM-DDTHH:mm:ss.sssssss
    if (typeFormat === 5)
      return DateUtil.convertFromLocalToUTCFullMiliseconds(value, true); // YYYY-MM-DDTHH:mm:ss.sssssss Only UTC
    if (typeFormat === 6)
    {
      const isValidFormat = /^\d{12}$/.test(value);
      if (!isValidFormat)
        return value;
      return DateUtil.getFormattedDateToShow(value); // MM/DD/YYYY HH:mm PM/AM  input yyyyMMddHHmm
    }
    if (typeFormat === 7)
      return DateUtil.showTimeOnly(value); // HH:mm
    if (typeFormat === 8)
          return DateUtil.getFormattedDateToShow(value, true); // MM/DD/YYYY HH:mm PM/AM  input yyyyMMddHHmm
    if (typeFormat === 9)
          return DateUtil.dateToMilitaryDate(value); // YYYY/MM/DD HH:mm:ss
    if (typeFormat === 10)
      return DateUtil.formatDDMMYYYYWithSeconds(value); // DD/MM/YYYY HH:mm:ss
  }
}